var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgParent = function SvgParent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.5C9.933 8.5 11.5 6.933 11.5 5C11.5 3.067 9.933 1.5 8 1.5C6.067 1.5 4.5 3.067 4.5 5C4.5 6.933 6.067 8.5 8 8.5Z",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98401 3.22266C6.0789 4.35869 7.5889 5.00033 9.16668 4.99999C9.95763 5.0003 10.7403 4.839 11.4667 4.52599",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.5C1.5 12.9101 4.41015 10 8 10C11.5899 10 14.5 12.9101 14.5 16.5",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.4994V11.0001C5.5 12.3808 6.61929 13.5001 8 13.5001C9.38071 13.5001 10.5 12.3808 10.5 11.0001V10.4994",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgParent);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDguNUM5LjkzMyA4LjUgMTEuNSA2LjkzMyAxMS41IDVDMTEuNSAzLjA2NyA5LjkzMyAxLjUgOCAxLjVDNi4wNjcgMS41IDQuNSAzLjA2NyA0LjUgNUM0LjUgNi45MzMgNi4wNjcgOC41IDggOC41WiIgc3Ryb2tlPSIjODg4RUE3IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC45ODQwMSAzLjIyMjY2QzYuMDc4OSA0LjM1ODY5IDcuNTg4OSA1LjAwMDMzIDkuMTY2NjggNC45OTk5OUM5Ljk1NzYzIDUuMDAwMyAxMC43NDAzIDQuODM5IDExLjQ2NjcgNC41MjU5OSIgc3Ryb2tlPSIjODg4RUE3IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS41IDE2LjVDMS41IDEyLjkxMDEgNC40MTAxNSAxMCA4IDEwQzExLjU4OTkgMTAgMTQuNSAxMi45MTAxIDE0LjUgMTYuNSIgc3Ryb2tlPSIjODg4RUE3IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS41IDEwLjQ5OTRWMTEuMDAwMUM1LjUgMTIuMzgwOCA2LjYxOTI5IDEzLjUwMDEgOCAxMy41MDAxQzkuMzgwNzEgMTMuNTAwMSAxMC41IDEyLjM4MDggMTAuNSAxMS4wMDAxVjEwLjQ5OTQiIHN0cm9rZT0iIzg4OEVBNyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";